
import styled from 'styled-components';


export const RadioLabel = styled.div(
    props => `
      display: block;
      position: relative;
      cursor: pointer;
      user-select: none;
      display: flex;
      align-items: center;
    `,
  );
  
  export const Checkmark = styled.span(
    props => `
      position: relative;
      height: 17px;
      width: 17px;
      background: white;
      border: solid 1.5px #647a97;
      border-radius:50%;
      &::after {
        display: none;
        content: '';
        left: 6px;
        top: 3px;
        position: absolute;
        width: 4px;
        height: 7px;
        border: solid white;
        border-width: 0 1px 1px 0;
        transform: rotate(45deg);
      }
    `,
  );

  export const Dot = styled.span(
    props =>`
      position: relative;
      display: flex;
      height: 1.8rem;
      width: 1.8rem;
      background-color: white;
      border-radius: 50%;
      border: 2px solid #4f525a;
      
      &:after {
        display: none;
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        background: ${props?.backgroundColor || "#2276e3"};
        transform: translate(-50%, -50%);
      }
    `
  );
  
  export const RadioInput = styled.input(
    props => `
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
  
      
      &:checked ~ ${Checkmark} {
        background:#2276e3;
        border: none;
        &::after {
          display: block;
        }
      }

      &:checked ~ ${Dot} {
        background:white;
        border: 2px solid ${props?.borderColor || "#2276e3"};
        &::after {
          display: block;
        }
      }
    `,
  );
  export const CheckboxText = styled.span(
    props => `
  
    display:flex;
    flex-wrap: wrap;
    padding-left: 1rem;
    
    &.active{
      color:#2276e3;
      
    }
  
  `,
  );
 
 

